import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const neverAgainItems = [
  "Manually map CSV columns.",
  "Build the same automation twice.",
  "Wonder if anyone updated the sheet.",
  "Chase people for form responses.",
  "Export → reformat → reimport.",
  "Explain your schema to a new hire.",
];

export const NeverAgainList = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 sm:py-20 md:py-28 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          {/* Timestamp */}
          <span className="text-xs font-mono text-muted-foreground mb-6 sm:mb-8 block">
            [ELIMINATED]
          </span>
          
          {/* List */}
          <ul className="space-y-3 sm:space-y-4 mb-10 sm:mb-12">
            {neverAgainItems.map((item, idx) => (
              <li
                key={idx}
                className="text-base sm:text-lg md:text-xl text-muted-foreground line-through decoration-muted-foreground/40 decoration-2 hover:text-foreground hover:no-underline transition-all duration-300 cursor-default px-4"
              >
                {item}
              </li>
            ))}
          </ul>
          
          {/* CTA */}
          <div className="space-y-4">
            <p className="text-base sm:text-lg font-medium text-foreground">
              Spend time on work that matters.
            </p>
            <Button 
              size="lg"
              className="h-12 px-6 sm:px-8 text-base font-medium group w-full sm:w-auto touch-target"
              onClick={() => navigate("/auth")}
            >
              Start free
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
